function fontbold() {
    if (null != this.EDMathUI.view) {
        this.EDMathUI.view.selectFontBold = !this.EDMathUI.uifontbold;
    }
}

function fontitalic() {
    if (null != this.EDMathUI.view) {
        this.EDMathUI.view.selectFontItalic = !this.EDMathUI.uifontitalic;
    }
}

function fontcolor(color) {
    if (null != this.EDMathUI.view) {
        this.EDMathUI.view.selectFontColor = color;
    }
}
export default {
    name: "",
    components: {},
    data() {
        return {
            fontbold,
            fontitalic,
            fontcolor,
        };
    },
};
